export enum ExternalNumberStatus {
    FREE = "Свободен", BUSY = "Занят", LOCKED = "Выбран на лендинге", SELECTED = "Выбран в ЛК"
}
